class BESSAppProjectEditorItem extends BESSAppBase {

    constructor(editor, itemData, itemView, inputs) {
        super();
        this.filters = {};
        this.editor = editor;
        this.itemData = itemData;
        this.itemIndex = editor.items.length;
        this.itemView = itemView;
        this.inputs = inputs;
        this.isInvalid = false;
        this.actionButtons = {
            moveUp: itemView.find('.app-move-up'),
            moveDown: itemView.find('.app-move-down'),
            copy: itemView.find('.app-copy'),
            remove: itemView.find('.app-remove'),
        };
    }

    initialise() {
        _.each(this.inputs.allInputs, function (x) {
            x.initialise();
            x.onChange(this.#checkToRevalidate.bind(this));
        }.bind(this));
        BESSAppComponent.initialiseFor(this.itemView);

        this.updateItemHeader();

        this.actionButtons.moveUp.bindClickEvent(this, this.#onMoveUp);
        this.actionButtons.moveDown.bindClickEvent(this, this.#onMoveDown);
        this.actionButtons.copy.bindClickEvent(this, this.#onCopy);
        this.actionButtons.remove.bindClickEvent(this, this.#onRemove);

        this.actionButtons.remove.showIf(this.itemData.canDelete);

        this.updateState();
    }

    updateItemHeader() {
        let headerName = this.itemView.find('thead .app-orig-value');

        if (this.itemData.name != null) {
            headerName.text(this.itemData.name);
        } else {
            let itemNameInput = this.inputs.allInputs[0];
            let itemName = itemNameInput.getValue();
            headerName.text(itemName);
        }
    }

    syncProjectWideInput(field, value) {
        _.forEach(this.inputs, function (input) {

            if (input.field === field) {
                input.setValue(value);
            }

        }.bind(this));
    }

    filterByFieldValue(fieldNo, value) {
        if (value === null) {
            this.filters[fieldNo] = true;
        } else {
            this.filters[fieldNo] = this._fieldValueIs(fieldNo, value);
        }
        let hasActiveFilters = true;
        _.forOwn(this.filters, function (value, key) {
            if (!value) {
                hasActiveFilters = false;
                return false;
            }
        });

        this.itemView.showIf(hasActiveFilters);
    }

    validate(focus = true) {
        let valid = true;
        let firstInvalid = null;
        _.each(this.inputs.allInputs, function (x) {
            if (!x.isHidden()) {
                let invalidReason = x.validate();
                let inputValid = invalidReason == null;
                x.node.find('.app-validation-parent').addClassIf('error', !inputValid);
                x.node.find('.app-error-label').showIf(!inputValid);
                if (!inputValid) {
                    if (firstInvalid === null) {
                        firstInvalid = x;
                    }
                    let invalidReasonId = uuid4();
                    x.node.find('.app-error-label').attr('id', invalidReasonId).html(invalidReason);
                    x.markInvalid(invalidReasonId);
                } else {
                    x.markValid();
                }
                valid = inputValid && valid;
            }
        }.bind(this));
        this.isInvalid = !valid;
        if (firstInvalid != null && focus) {
            firstInvalid.focus();
        }
        return valid;
    }

    isValid() {
        let valid = true;
        _.each(this.inputs.allInputs, function (x) {
            if (!x.isHidden()) {
                let invalidReason = x.validate();
                let inputValid = invalidReason == null;
                valid = inputValid && valid;
            }
        }.bind(this));
        return valid;
    }

    updateState() {
        let items = this.editor.data.items;
        this.actionButtons.moveUp.hideIf(this.itemData === items[0] || items.length === 1);
        this.actionButtons.moveDown.hideIf(this.itemData === items[items.length - 1] || items.length === 1);
    }

    hasChanges() {
        return _.filter(this.inputs.allInputs, (x) => x.hasChanged()).length > 0;
    }

    focus() {
        this.itemView[0].scrollIntoView({behavior: 'smooth', block: 'center'});
        let inputs = this.inputs.allInputs;
        for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].focus()) {
                return;
            }
        }
    }

    hide() {
        this.itemView.hide();
    }

    show() {
        this.itemView.show();
    }

    fadeOut(doneFn) {
        this.itemView.animate({
            opacity: 0.1,
        }, 200, doneFn);
    }

    fadeInAndFocus() {
        this.itemView.css({opacity: 0.1}).animate({
            opacity: 1,
        }, 200, this.focus.bind(this));
    }

    #checkToRevalidate() {
        if (this.isInvalid) {
            this.validate(false);
        }
    }

    #onMoveUp() {
        this.editor.moveItemUp(this);
    }

    #onMoveDown() {
        this.editor.moveItemDown(this);
    }

    #onCopy() {
        this.editor.copyItem(this);
    }

    #onRemove() {
        this.editor.removeItem(this);
    }

    _fieldValueIs(fieldNo, value) {
        if (this.editor.data.fields[fieldNo].inputType === BESSAppInputType.tags) {
            let tags = this.itemData.values[fieldNo].value;
            if (tags !== null && value !== null) {
                return tags.indexOf(value) !== -1;
            }
            return false;
        }

        return String(this.itemData.values[fieldNo].value) === String(value);
    }
}